module.exports = __webpack_public_path__ + "img/menu_seminar.2628079f.jpg";